@use "../../../styles/breakpoint.module.scss" as *;

.tile {
    background: var(--color-primary);
    color: var(--color-contrast);
    grid-row: span 2;
    gap: 0;
    display: grid;
    grid-template-rows: subgrid;
    overflow: hidden;
    cursor: pointer;

    &:hover {
        .picture {
            scale: 1.02;
        }
    }

    @media ($below-mobile) {
        display: flex;
    }
}

.tileSelected {
    composes: tile;
    outline: var(--outline);
    outline-offset: 1px;
}

.picture {
    aspect-ratio: 1;
    max-width: 100%;
    place-self: center;
    transition: scale 0.2s;
}

.pictureSmall {
    composes: picture;
    width: 56%;
}

.pictureMedium {
    composes: picture;
    width: 72%;
}

.pictureLarge {
    composes: picture;
    width: 80%;
}

.pictureFull {
    composes: picture;
    width: 100%;
    aspect-ratio: 1.75;
}

.image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.content {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: var(--spacer-24);

    @media ($below-mobile) {
        justify-content: center;

        &:has(.sku) {
            text-align: left;

            .label {
                text-align: left;
            }

            .detailsLink {
                align-self: flex-start;
            }
        }
    }
}

.sku {
    margin-bottom: var(--spacer-4);
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.label {
    display: block;
    flex-grow: 1;
    font: var(--font-h-24);
    text-align: center;
    text-wrap: pretty;

    @media ($below-mobile) {
        flex-grow: 0;
    }
}

.description {
    flex-grow: 1;
    margin-top: var(--spacer-8);
    font: var(--font-p-14);
    text-wrap: pretty;

    @media ($below-mobile) {
        flex-grow: 0;
    }
}

.price {
    margin-top: var(--spacer-8);
    font: var(--font-p-14);
}

.detailsLink {
    align-self: center;
    margin-top: var(--spacer-16);
    font: var(--font-text-link-12);
    text-decoration: underline;
}
